import type { WithdrawalRequestWithAccount } from 'api';

import { withdrawalRequestStatuses } from 'models/withdrawal';

import { StatusTag } from '@atoms/StatusTag';

import { FormattedDateTime } from '@molecules/FormattedDateTime';

type Props = {
  withdrawalRequestFullData: WithdrawalRequestWithAccount;
};

export const WithdrawalDetailsHistory = ({
  withdrawalRequestFullData
}: Props) => {
  const reversedTransitions = [
    ...withdrawalRequestFullData.status_transitions
  ].reverse();

  return reversedTransitions.map((transition, index) => {
    return (
      <div className="details-section-items-container" key={index}>
        <div className="flex flex-col justify-between gap-1">
          <div className="text-xs">Status</div>
          <StatusTag
            status={transition?.status}
            statuses={withdrawalRequestStatuses}
          />
        </div>
        <div className="flex flex-col justify-end">
          <FormattedDateTime value={transition?.created_at} />
        </div>
      </div>
    );
  });
};
